export default __webpack_public_path__ + "static/alyeska-alaska-7b20dd484242a4334f4d09a5d0824242.jpg";